import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import { incidentReportApi } from 'shared/services/incidentReportApi';
import { queryKeys } from '../queryConfig';

export interface IncidentReportsFilters {
  company?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export const useIncidentReports = (filters: IncidentReportsFilters = {}) => {
  const queryParams = {
    page: filters.page || 1,
    limit: filters.limit || 20,
    ...(filters.company && { company: filters.company }),
    ...(filters.status && { status: filters.status }),
  };

  return useQuery({
    queryKey: queryKeys.incidentReports.list(queryParams, filters.company || ''),
    queryFn: () => incidentReportApi.getAll(queryParams),
    placeholderData: keepPreviousData,
  });
};

export const useIncidentReportStats = (company?: string) => {
  return useQuery({
    queryKey: queryKeys.incidentReports.stats(company || ''),
    queryFn: () => incidentReportApi.getStats({ company }),
  });
};

export const useDeleteIncidentReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => incidentReportApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.incidentReports.all });
    },
  });
};

